import Rellax from 'rellax'

let rellax = []
let paralaxes = document.querySelectorAll(".paralax")

paralaxes.forEach((paralax, i) => {
    rellax[i] = new Rellax(paralax, {
        relativeToWrapper: true,
        wrapper: paralax.parentElement,
    });

    if (window.innerWidth <= 1024) {
        paralax.dataset.rellaxSpeed = paralax.dataset.rellaxSpeed / 2;
        rellax[i].refresh();
    }
})

window.removeEventListener("scroll", () => {
    rellax.forEach((e) => {
        e.refresh()
    })
});

window.addEventListener("scroll", () => {
    rellax.forEach((e) => {
        e.refresh()
    })
});